import { render } from "./GeneralView.vue?vue&type=template&id=17dd6945&scoped=true"
import script from "./GeneralView.vue?vue&type=script&lang=js"
export * from "./GeneralView.vue?vue&type=script&lang=js"

import "./GeneralView.vue?vue&type=style&index=0&id=17dd6945&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dd6945"]])

export default __exports__